// HOPP Solid — base structure config for the /hoppsolid page.
//
// All content fields are intentionally empty placeholders. When the real copy,
// technical specs and reference materials arrive, fill them in here — no
// component changes needed.
//
// Each technology supports:
//   intro            — short intro paragraph
//   advantages       — bullet list of benefits
//   shellSpec        — "szerkezetkész" technical content (string or list)
//   turnkeySpec      — "kulcsrakész" technical content (string or list)
//   images           — [{ src, alt }]
//   references       — [{ title, description, image }]
//
// Each contractor supports:
//   intro            — short intro
//   technologies     — ids referencing the technologies they build with
//   references       — [{ title, description, image, technologies }]
//   technicalContent — related technical documentation (string or list)

export const hoppSolidConfig = {
  seo: {
    title: 'HOPP Solid – Prémium építkezés',
    description:
      'HOPP Solid: mit építünk, milyen technológiákkal, milyen készültségi szinten, kik építik, referenciák.',
  },

  brand: {
    name: 'HOPP Solid',
    primaryColor: '#e31937',
    darkBg: '#0a0a0a',
    cardBg: '#161616',
  },

  hero: {
    eyebrow: 'A HOPPx ökoszisztéma része',
    title: 'HOPP SOLID',
    tagline: 'Prémium építkezés, átláthatóan.',
    // The five anchor questions communicated at the top level.
    questions: [
      { id: 'mit-epitunk', label: 'MIT ÉPÍTÜNK?' },
      { id: 'technologiak', label: 'MILYEN TECHNOLÓGIÁKKAL ÉPÍTÜNK?' },
      { id: 'keszultseg', label: 'MILYEN KÉSZÜLTSÉGI SZINTEN KÉRHETŐ?' },
      { id: 'kik-epitik', label: 'KIK ÉPÍTIK?' },
      { id: 'referenciak', label: 'REFERENCIÁK' },
    ],
  },

  sections: {
    mitEpitunk: { title: 'MIT ÉPÍTÜNK?', content: null },
    keszultseg: { title: 'MILYEN KÉSZÜLTSÉGI SZINTEN KÉRHETŐ?', content: null },
  },

  technologies: [
    {
      id: 'fa-szerkezet',
      name: 'Fa szerkezet',
      intro: null,
      advantages: [],
      shellSpec: null,
      turnkeySpec: null,
      images: [],
      references: [],
    },
    {
      id: 'tegla',
      name: 'Tégla',
      intro: null,
      advantages: [],
      shellSpec: null,
      turnkeySpec: null,
      images: [],
      references: [],
    },
    {
      id: 'fem-szerkezet',
      name: 'Fém szerkezet',
      intro: null,
      advantages: [],
      shellSpec: null,
      turnkeySpec: null,
      images: [],
      references: [],
    },
    {
      id: 'viablock',
      name: 'Viablock',
      intro: null,
      advantages: [],
      shellSpec: null,
      turnkeySpec: null,
      images: [],
      references: [],
    },
    {
      id: 'proconcept',
      name: 'ProConcept',
      intro: null,
      advantages: [],
      shellSpec: null,
      turnkeySpec: null,
      images: [],
      references: [],
    },
  ],

  contractors: [
    {
      id: 'contractor-1',
      name: 'Kivitelező partner #1',
      intro: null,
      technologies: [],
      references: [],
      technicalContent: null,
    },
    {
      id: 'contractor-2',
      name: 'Kivitelező partner #2',
      intro: null,
      technologies: [],
      references: [],
      technicalContent: null,
    },
  ],
};
